import Form from "../../Form/Form";
import SideContent from "../SideContent/SideContent";

function FullWidth()
{
    return (
        <div className="full-container">
            <div className="full-container__wrapper">
                <SideContent />
                <Form />
            </div>
        </div>
    )
}

export default FullWidth;